export const animationObj = {
  horizontalLtr: {
    "0%": {
      transform: "translateX(-195px)",
    },

    "100%": {
      transform: "translateX(195px)",
    },
  },
  horizontalSidebarRtl: {
    "0%": {
      transform: "translate(0)",
      backgroundColor: "yellow",
    },
    "100%": {
      transform: "translate(-370px)",
      backgroundColor: "yellow",
    },
  },
  reverseHorizontalSidebarRtl: {
    "0%": {
      transform: "translate(-370px)",
      backgroundColor: "#4dabf5",
    },
    "100%": {
      transform: "translate(0)",
      backgroundColor: "#4dabf5",
    },
  },
};
